import { render, staticRenderFns } from "./_createAccountStep.vue?vue&type=template&id=19742638"
import script from "./_createAccountStep.vue?vue&type=script&lang=js"
export * from "./_createAccountStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports